const ProductData = [
    {
        id: 1,
        title: 'Pearl Milk Tea',
        price: 4.25,
    },
    {
        id: 2,
        title: 'Brown Sugar Milk Tea',
        price: 4.95,
    },
    {
        id: 3,
        title: 'Roasted Milk Tea',
        price: 4.25,
    },
    {
        id: 4,
        title: 'Taro Milk Tea',
        price: 4.25,
    },
    {
        id: 5,
        title: 'Caramel Milk Tea',
        price: 4.25,
    },
    {
        id: 6,
        title: 'Sago Milk Tea',
        price: 4.25,
    },
    {
        id: 7,
        title: 'Matcha Milk Tea',
        price: 4.25,
    },
    {
        id: 8,
        title: 'Red Bean Milk Tea',
        price: 4.75,
    },
    {
        id: 9,
        title: 'Grass Jelly Milk Tea',
        price: 4.55,
    },
]

export default ProductData
